import { ref } from 'vue';

export interface HeadingItem {
    level: number;
    text: string;
    pos: number;
}

// Module-level singletons — shared across all components in the same page load.
const headings = ref<HeadingItem[]>([]);
const onJump = ref<((pos: number) => void) | null>(null);

export function useEditorOutline() {
    return { headings, onJump };
}
